<template>
  <div>
    <div class="col-6 d-flex align-items-center justify-content-lg-start">
      <Button
        v-if="showBackButton && actionType === 'save' || 'add'"
        label="List page"
        size="md"
        icon="ArrowLeftIcon"
        show-icon
        class="mb-1"
        @click="backNavigationAction"
      />
    </div>
    <form-wizard
      ref="casaProduct"
      :title="null"
      :subtitle="null"
      layout="vertical"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
    >

      <!-- Savings/Current Product Information tab -->
      <tab-content
        title="Savings/Current"
        :before-change="validateSavings"
      >
        <validation-observer ref="savingRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Savings/Current Product Information
                </h5>
              </b-col>
              <b-col md="6">
                <InputField
                  id="name-of-product"
                  v-model="casaProductFormData.name"
                  label=" Name of Product"
                  placeholder="Enter name of product"
                  type="text"
                  error-name="Name of Product"
                  rules="required"
                  :readonly="isReadonly"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- Product Code -->
              <b-col md="6">
                <InputField
                  id="product-code"
                  v-model.number="casaProductFormData.code"
                  label="Product Code"
                  placeholder="Enter product code"
                  type="number"
                  error-name="Product Code"
                  rules="required|integer|length:3"
                  :readonly="isEditProductCode"
                />
              </b-col>
              <!-- Product Code -->

              <!--  Product Category -->
              <b-col md="6">
                <SelectField
                  id="product-category"
                  v-model="casaProductFormData.category"
                  :reduce="option => option.value"
                  label="Product Category"
                  :options="productCategoryOptions"
                  placeholder="Select"
                  error-name="Product Category"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <!--  Product Category -->
              <!--  Account Number Starting Prefix -->
              <b-col md="6">
                <InputField
                  id="account-number-prefix"
                  v-model.number="casaProductFormData.accountNumberPrefix"
                  label="Account Number Starting Prefix"
                  placeholder="Enter Account Number Starting Prefix"
                  type="number"
                  error-name="Account Number Starting Prefix"
                  rules="integer|positive|max:1"
                  :readonly="isReadonly"
                />
              </b-col>
              <!--  Account Number Starting Prefix -->

              <!--  Currency -->
              <b-col md="6">
                <SelectField
                  id="currency-code"
                  v-model="casaProductFormData.currencyCode"
                  :reduce="option => option"
                  label="Currency"
                  :options="currencyCodeOptions"
                  placeholder="Select"
                  :error-name="actionType === 'add' ? 'Currency' : ''"
                  :rules="actionType === 'add' ? 'required' : ''"
                  item="label"
                  :readonly="isEditProductCode"
                />
              </b-col>
              <!--  Currency -->
            </b-row>

          </b-form>
        </validation-observer>

      </tab-content>

      <!-- CAM/Fee Specification tab -->
      <tab-content
        title="CAM/Fee"
        :before-change="validateCAM"
      >
        <validation-observer ref="camRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  CAM/Fee Specification
                </h5>
                <!-- <small class="text-muted">Provide more info about the loan size</small> -->
              </b-col>

              <b-col md="6">
                <SelectField
                  id="credit-interest"
                  v-model="casaProductFormData.applyFee"
                  label="Apply Fee"
                  :options="feeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Apply Fee"
                  rules="required"
                  item="label"
                  :set-selected="setApplyFee"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col
                v-if="isConditionalFee"
                md="6"
              >
                <SelectField
                  id="conditional"
                  v-model="feeConditionBasis"
                  label="Conditional"
                  :options="conditionalOptions"
                  placeholder="Select"
                  error-name="Conditional"
                  rules="required"
                  :reduce="option => option.value"
                  item="label"
                  :set-selected="setProductFee"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>

            <div
              v-if="isConditionalFee"
              class="mb-5"
            >
              <b-form
                ref="productFeeForm"
                class="repeater-form"
                :style="{height: trHeight}"
                @submit.prevent="repeatProductFees"
              >

                <!-- Row Loop -->
                <b-row
                  v-for="(item, index) in casaProductFormData.productFees"
                  :id="item.id"
                  :key="item.id"
                  ref="productFees"
                >
                  <b-col
                    md="3"
                  >
                    <!-- No of Withdrawals(times) -->
                    <InputNumberField
                      :id="isFeeNoOfWithdrawal ? 'number-of-withdrawal' : 'customer-balance'"
                      v-model.number="item.feeConditionValue"
                      :label="isFeeNoOfWithdrawal ? 'No of Withdrawal' : 'Customer Balance (Amount)'"

                      :error-name="isFeeNoOfWithdrawal ? 'No of Withdrawal' : 'Customer Balance'"
                      rules="required"
                      :readonly="isReadonly"
                    />
                  </b-col>

                  <!-- Conditional -->
                  <b-col md="4">
                    <SelectField
                      id="fee"
                      v-model="item.feeID"
                      :reduce="option => option.value"
                      label="Fee"
                      :options="camFeeOptions"
                      placeholder="Select Fee"
                      error-name="Fee"
                      rules="required"
                      item="label"
                      :set-selected="setProductCAMFee"
                      :readonly="isReadonly"
                    />
                  </b-col>
                  <b-col md="3">
                    <!-- Flat Amount -->
                    <InputField
                      id="flat-amt"
                      v-model.number="item.flatAmount"
                      label="Flat Amount"
                      type="number"
                      readonly
                    />
                  </b-col>
                  <b-col md="2">
                    <!-- Amount Per Transaction -->
                    <InputField
                      id="amt-per-trans"
                      v-model.number="item.amountPerTrans"
                      label="Amount per Trans"
                      type="number"
                      readonly
                    />
                  </b-col>
                  <b-col md="3">
                    <!-- Percentage on Turnover -->
                    <InputField
                      id="percentage-on-turnover"
                      v-model.number="item.percentageOnTurnover"
                      label="% on Turnover"
                      type="number"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <!-- Minimum Amount To Charge -->
                    <InputField
                      id="min-amount-to-charge"
                      v-model.number="item.minAmountToCharge"
                      label="Minimum Amount"
                      type="number"
                      readonly
                    />
                  </b-col>

                  <b-col md="3">
                    <!-- Maximum Amount To Charge -->
                    <InputField
                      id="maximum-amount-to-charge"
                      v-model.number="item.maxAmountToCharge"
                      label="Maximum Amount"
                      type="number"
                      readonly
                    />
                  </b-col>

                  <b-col
                    md="2"
                    class="mt-2"
                  >
                    <!-- Remove Button -->

                    <feather-icon
                      v-if="actionType !== 'view'"
                      v-b-tooltip.hover.bottom="'Remove'"
                      icon="XIcon"
                      class="mr-25 cursor-pointer text-danger"
                      @click="removeProductFeeItem(index)"
                    />

                  </b-col>

                </b-row>

              </b-form>

              <b-button
                v-show="showAddProductFee"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="repeatProductFees"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Add New Condition</span>
              </b-button>
            </div>
          </b-form>
        </validation-observer>
        <b-row v-if="isApplyFee">
          <b-col md="6">
            <SelectField
              id="fee"
              v-model="feeID"
              :reduce="option => option.value"
              label="Fee"
              :options="camFeeOptions"
              placeholder="Select Fee"
              error-name="Fee"
              rules="required"
              item="label"
              :set-selected="setCAMFees"
              :readonly="isReadonly"
            />
          </b-col>

          <b-col md="6">
            <InputField
              id="flat-amount"
              v-model="nonEditable.flatAmount"
              label="Flat Amount"
              type="text"
              readonly
            />
          </b-col>

          <b-col md="6">
            <InputNumberField
              id="flat-amount-per-transaction"
              v-model.number="nonEditable.amountPerTrans"
              label="Flat Amount Per Transaction"
              readonly
            />
          </b-col>

          <b-col md="6">
            <InputField
              id="percentage-on-turnover"
              v-model="nonEditable.percentageOnTurnover"
              label="Percentage on Turnover"
              type="text"
              readonly
            />
          </b-col>

          <b-col md="6">
            <InputNumberField
              id="minimum-amount-to-charge"
              v-model="nonEditable.minAmountToCharge"
              label="Minimum Amount to Charge"
              readonly
            />
          </b-col>

          <b-col md="6">
            <InputNumberField
              id="maximum-amount-to-charge"
              v-model="nonEditable.maxAmountToCharge"
              label="Maximum Amount to Charge"
              readonly
            />
          </b-col>
        </b-row>
      </tab-content>

      <!-- Credit Interest Specification -->
      <tab-content
        title="Credit Profit"
        :before-change="validateCredit"
      >
        <validation-observer ref="creditRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Credit Profit Specification
                </h5>
                <!-- <small class="text-muted">Provide more information about the loan tenure</small> -->
              </b-col>

              <b-col md="6">
                <SelectField
                  id="credit-interest"
                  v-model="casaProductFormData.applyCreditInterest"
                  label="Apply Credit Profit"
                  :reduce="option => option.value"
                  :options="applyOptions"
                  placeholder="Select"
                  error-name="Credit Profit"
                  rules="required"
                  item="label"
                  :set-selected="setApplyCreditInterest"
                  :readonly="isReadonly"
                />
              </b-col>

              <!-- Conditional -->
              <b-col
                v-if="isConditional"
                md="6"
              >
                <SelectField
                  id="conditional"
                  v-model="interestConditionBasis"
                  label="Conditional"
                  :reduce="option => option.value"
                  :options="conditionalOptions"
                  placeholder="Select"
                  error-name="Conditional"
                  rules="required"
                  item="label"
                  :set-selected="setProductInterest"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>

            <div
              v-if="isConditional"
              class="mb-5"
            >
              <b-form
                ref="form"
                class="repeater-form"
                :style="{height: trHeight}"
                @submit.prevent="repeatProductInterest"
              >

                <!-- Row Loop -->
                <b-row
                  v-for="(item, index) in casaProductFormData.productInterests"
                  :id="item.id"
                  :key="item.id"
                  ref="productInterest"
                >
                  <b-col md="3">
                    <!-- No of Withdrawals(times) -->
                    <InputField
                      :id="isInterestNoOfWithdrawal ? 'number-of-withdrawal' : 'customer-balance'"
                      v-model.number="item.interestConditionValue"
                      type="number"
                      :label="isInterestNoOfWithdrawal ? 'No of Withdrawals' : 'Customer Balance (Amount)'"
                      :error-name="isInterestNoOfWithdrawal ? 'No of Withdrawal' : 'Balance'"
                      rules="required"
                      :readonly="isReadonly"
                    />
                  </b-col>

                  <b-col md="4">
                    <!-- Credit Interest -->
                    <SelectField
                      id="credit-interestt"
                      v-model="item.interestID"
                      label="Profit"
                      :reduce="option => option.value"
                      :options="creditInterestOptions"
                      placeholder="Select"
                      error-name="Credit Profit"
                      rules="required"
                      item="label"
                      :set-selected="setProductCreditInterestFee"
                      :readonly="isReadonly"
                    />
                  </b-col>

                  <b-col md="3">
                    <!-- Credit Interest Rate -->
                    <InputField
                      id="credit-interest-rate"
                      v-model.number="item.interestRate"
                      label="Rate"
                      type="number"
                      readonly
                    />
                  </b-col>

                  <b-col
                    md="2"
                    class="mt-2"
                  >
                    <!-- Remove Button -->

                    <feather-icon
                      v-if="actionType !== 'view'"
                      v-b-tooltip.hover.bottom="'Remove'"
                      icon="XIcon"
                      class="mr-25 cursor-pointer text-danger"
                      @click="removeProductInterestItem(index)"
                    />

                  </b-col>

                </b-row>

              </b-form>

              <b-button
                v-show="showAddProductInterest"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="repeatProductInterest"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Add New Condition</span>
              </b-button>
            </div>

            <b-row v-if="isCreditInterest">

              <b-col md="6">
                <SelectField
                  id="credit-interest"
                  v-model="interestID"
                  label="Credit Profit"
                  :options="creditInterestOptions"
                  :reduce="option => option.value"
                  placeholder="Select credit profit"
                  error-name="Credit Profit"
                  rules="required"
                  item="label"
                  :set-selected="setCreditInterestFee"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="credit-interest-rate"
                  v-model.number="interestRate"
                  label="Credit Profit Rate"
                  readonly
                  type="number"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <ValidationObserver>
                  <b-row>
                    <b-col md="6">
                      <InputNumberField
                        id="minimum-product-balance"
                        v-model="casaProductFormData.minimumBalance"
                        label="Minimum Product Balance"
                        placeholder="Enter minimum product balance"
                        error-name="Minimum Product Balance"
                        rules="required|integer|amount:@maxFee|positive"
                        :readonly="isReadonly"
                      />
                    </b-col>

                    <b-col md="6">
                      <InputNumberField
                        id="maximum-product-balance"
                        v-model="casaProductFormData.maximumBalance"
                        label=" Maximum Product Balance"
                        vid="maxFee"
                        placeholder="Enter maximum product balance"
                        error-name=" Maximum Product Balance"
                        rules="required|integer|positive"
                        :readonly="isReadonly"
                      />
                    </b-col>
                  </b-row>
                </ValidationObserver>
              </b-col>
              <b-col md="6">
                <InputField
                  id="no-of-days-dormancy"
                  v-model.number="casaProductFormData.noOfDaysToDormancy"
                  label="No of Days to Dormancy"
                  placeholder="Enter no of days to dormancy"
                  type="number"
                  error-name="No of Days to Dormancy"
                  rules="required|integer"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="no-of-days-inactive"
                  v-model.number="casaProductFormData.noOfDaysToInactive"
                  label="No of Days to Inactive"
                  placeholder="Enter no of days to Inactive"
                  type="number"
                  error-name="No of Days to Inactive"
                  rules="required|integer"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>

      </tab-content>

      <!-- Reporting Account Information -->
      <tab-content
        title="Reporting Account"
        :before-change="validateReporting"
      >
        <validation-observer ref="reportingRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Reporting Account Information
                </h5>
              </b-col>

              <b-col md="6">
                <SelectField
                  id="overdraft-account"
                  v-model="casaProductFormData.overdraftAccountNumber"
                  label="Overdraft Account"
                  :options="overdraftOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Overdraft Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="interest-payable-account"
                  v-model="casaProductFormData.interestPayableAccountNumber"
                  label="Profit Payable Account"
                  :reduce="option => option.value"
                  :options="interestPayableOptions"
                  placeholder="Select"
                  error-name="Profit Payable Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="interest-expense-account"
                  v-model="casaProductFormData.interestExpenseAccountNumber"
                  label="Profit Expense Account"
                  :reduce="option => option.value"
                  :options="interestExpenseOptions"
                  placeholder="Select"
                  error-name="Profit Expense Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="due-unpaid-overdraft"
                  v-model="casaProductFormData.interestDueAndUnpaidAccountNumber"
                  label="Due and Unpaid Overdraft Profit Account"
                  :options="dueAndUnpaidInterestOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name="Due and Unpaid Overdraft Profit Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="interest-receivable-account"
                  v-model="casaProductFormData.interestReceivableAccountNumber"
                  label="Profit Receivable Account"
                  :options="interestReceivableOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Profit Receivable Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="interest-suspense-account"
                  v-model="casaProductFormData.interestSuspenseAccountNumber"
                  label="Profit in Suspense Account"
                  :options="interestInSuspenseOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Profit in Suspense Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="overdraft-fee-income-account"
                  v-model="casaProductFormData.overdraftFeeIncomeAccountNumber"
                  label="Overdraft Fee Income Account"
                  :options="overdraftFeeIncomeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Overdraft Fee Income Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="overdraft-interest-account"
                  v-model="casaProductFormData.overdraftInterestIncomeAccountNumber"
                  label=" Overdraft Profit Income Account"
                  :options="overdraftIncomeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name=" Overdraft Profit Income Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="vat-account"
                  v-model="casaProductFormData.vaTaccountNumber"
                  label="VAT Account"
                  :options="vatOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="VAT Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="wht-account"
                  v-model="casaProductFormData.whTaccountNumber"
                  label="WHT Account"
                  :options="witholdingTaxOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="WHT Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Fees Account Configuration -->
      <tab-content
        title="Fees"
        :before-change="validateFee"
      >
        <validation-observer ref="feeRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Fees Account Configuration
                </h5>
                <!-- <small class="text-muted">Provide more details about the interest repayment</small> -->
              </b-col>

              <b-col md="6">
                <SelectField
                  id="cam-fee-income"
                  v-model="casaProductFormData.coTfeeIncomeAccountNumber"
                  label="CAM Fee Income Account"
                  :options="camFeeIncomeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="CAM Fee Income Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="due-unpaid-fees"
                  v-model="casaProductFormData.dueAndUnpaidFeeAccountNumber"
                  label="Due and Unpaid Fees Account"
                  :options="dueAndUnpaidFeesOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name="Due and Unpaid Fees Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="suspended-fees-account"
                  v-model="casaProductFormData.suspendedFeeAccountNumber"
                  label="Suspended Fees Account"
                  :reduce="option => option.value"
                  :options="suspendedFeeOptions"
                  placeholder="Select"
                  error-name="Suspended Fees Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

            </b-row>

            <h6 class="section-label mx-1 mb-2 mt-2">
              Account Opening Information
            </h6>

            <b-col md="6">
              <SwitchButton
                v-model="casaProductFormData.chargeForAccountOpening"
                label=" Charge For Account Opening"
                name="account-opening"
                class="mt-2"
                :readonly="isReadonly"
              />
            </b-col>

            <b-row v-if="setAccountOpeningCharge(casaProductFormData.chargeForAccountOpening)">
              <b-col md="6">
                <InputNumberField
                  id="account-opening-charge"
                  v-model="casaProductFormData.accountOpeningCharge"
                  label="Account Opening Charge Amount"
                  placeholder="Enter account opening charge amount"
                  error-name="Account Opening Charge Amount"
                  rules="required|positive"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="account-opening-fee"
                  v-model="casaProductFormData.accountOpeningFeeIncomeAccountNumber"
                  label="Account Opening Fee Income Account"
                  :options="accountOpeningFeeOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name="Account Opening Fee Income Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="account-opening-charge-narration"
                  v-model="casaProductFormData.accountOpeningNarration"
                  label="Account Opening Charge Narration"
                  placeholder="Enter account opening charge narration"
                  type="text"
                  error-name="Account Opening Charge Narration"
                  rules="required"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!--  Account Maintenance Fee Configuration -->
      <tab-content
        title="Account Maintenance"
        :before-change="validateAccountMaintenance"
      >
        <validation-observer ref="maintenanceRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Account Maintenance
                </h5>
                <!-- <small class="text-muted">Provide more details about the reporting GLs</small> -->
              </b-col>
              <b-col md="6">
                <SwitchButton
                  v-model="casaProductFormData.chargeForAccountMaintenance"
                  label="Charge Account Maintenance Fee"
                  name="account-maintenance"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row v-if="setAccountMaintenance(casaProductFormData.chargeForAccountMaintenance)">
              <b-col md="6">
                <SelectField
                  id="account-maintenance-fee"
                  v-model="casaProductFormData.maintenanceFeeID"
                  label="Account Maintenance Fee"
                  :options="accountMaintenanceFeeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Account Maintenance Fee"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="account-maintenance-income"
                  v-model="casaProductFormData.accountMaintenanceFeeIncomeAccountNumber"
                  label="Account Maintenance Fee Income Account"
                  :options="accountOpeningFeeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Account Maintenance Fee Income Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="due-unpaid-account"
                  v-model="casaProductFormData.dueAndUnpaidMaintenanceFeeIncomeAccountNumber"
                  label="Due & Unpaid Account Maintenance Fee Account"
                  :options="dueAndUnpaidFeesOptions"
                  placeholder="Select"
                  error-name="Due & Unpaid Account Maintenance Fee Account"
                  rules="required"
                  :reduce="option => option.value"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="suspended-account-maintenance"
                  v-model="casaProductFormData.suspendedMaintenanceFeeIncomeAccountNumber"
                  label="Suspended Account Maintenance Fees Account"
                  :options="suspendedFeeOptions"
                  placeholder="Select"
                  error-name="Suspended Account Maintenance Fees Account"
                  rules="required"
                  :reduce="option => option.value"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputNumberField
                  id="minimum-balance-on-account"
                  v-model="casaProductFormData.minimumMaintenanceBalance"
                  label=" Minimum Balance on Account for Maintenance fee not to apply"
                  placeholder="Enter minimum balance"
                  error-name="Minimum Balance on Account for Maintenance fee not to apply"
                  rules="required|positive"
                  :readonly="isReadonly"
                />
              </b-col>

            </b-row>

            <b-row>
              <b-col md="6">
                <SwitchButton
                  v-model="casaProductFormData.maintenanceOnActiveAccountsOnly"
                  label="Charge only Active Accounts"
                  name="active-accounts"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!--  SMS Notification Charge Configuration -->
      <tab-content
        title="SMS Notification"
        :before-change="validateChargeConfiguration"
      >
        <validation-observer ref="chargeConfigurationRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  SMS Notification Charge Configuration
                </h5>
              </b-col>
              <b-col md="6">
                <InputNumberField
                  id="sms-charge-per-notification"
                  v-model="casaProductFormData.smsChargePerNotification"
                  label="SMS Charge Per Notification"
                  placeholder="Enter SMS Charge Per Notification"
                  error-name="SMS Charge Per Notification"
                  rules="required|integer"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="sms-fee-income-account"
                  v-model="casaProductFormData.smsFeeIncomeAccountNumber"
                  label="SMS Fee Income Account"
                  :options="accountOpeningFeeOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name="SMS Fee Income Account"
                  rules="required"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <SwitchButton
                  v-model="casaProductFormData.waiveSMSChargeForStaffAccount"
                  label="Waive SMS Charge For Staff Account"
                  name="waive-sms-charge-staff-account"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <InputNumberField
                  id="min-balance-to-stop-sms"
                  v-model="casaProductFormData.minimumAccountBalanceToStopSendingSMS"
                  label="Min. Account Balance To Stop Sending SMS"
                  placeholder="Enter Min. Account Balance To Stop Sending SMS"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <InputNumberField
                  id="min-amount-to-skip-sms"
                  v-model="casaProductFormData.minimumTransactionAmountToSkipSMS"
                  label="Min. Transaction Amount To Skip SMS "
                  placeholder="Enter Min. Transaction Amount To Skip SMS "
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>
      <template
        slot="finish"
      >
        <div class="wizard-footer-right">
          <Button
            v-if="actionType !== 'view'"
            label="Submit"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>

      </template>
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BForm,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { toastAlert } from '@core/mixins/toast'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { mapActions } from 'vuex'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import {
  productCategory, applyInterest, conditionalOptions,
} from '../../../../../helpers/data'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import Button from '../../../../components/button/Button.vue'
import SwitchButton from '../../../../components/switch/Switch.vue'
import { toKobo, formatAmount } from '../../../../../helpers/formatAmount'
import { accountPermissions } from '../../../../../helpers/permissions'
// import convertZeroToString from '@/helpers/convertZeroToString'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BForm,
    BCol,
    ValidationObserver,
    BButton,
    SwitchButton,
    Button,
    InputField,
    SelectField,
    FullScreenSpinner,
    InputNumberField,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [toastAlert, sweetAlert, heightTransition],
  data() {
    return {
      isDisabled: false,
      isLoading: false,
      isReadonly: false,
      isEditProductCode: false,
      showSpinner: false,
      showBackButton: false,
      actionType: 'save',
      selected: 'Limited',
      isVisible: false,
      isCreditInterest: false,
      isConditional: false,
      isApplyFee: false,
      isConditionalFee: false,
      isInterestNoOfWithdrawal: false,
      isFeeNoOfWithdrawal: false,
      showAddProductInterest: false,
      showAddProductFee: false,
      required,
      nonEditable: {
        flatAmount: '',
        amountPerTrans: '',
        percentageOnTurnover: '',
        minAmountToCharge: '',
        maxAmountToCharge: '',
      },
      casaProductFormData: {
        code: '',
        name: '',
        category: '',
        accountNumberPrefix: null,
        overdraftAccountNumber: '',
        interestPayableAccountNumber: '',
        interestExpenseAccountNumber: '',
        interestReceivableAccountNumber: '',
        interestDueAndUnpaidAccountNumber: '',
        interestSuspenseAccountNumber: '',
        overdraftFeeIncomeAccountNumber: '',
        overdraftInterestIncomeAccountNumber: '',
        vaTaccountNumber: '',
        whTaccountNumber: '',
        applyFee: '',
        feeCode: '',
        interestCode: '',
        applyCreditInterest: '',
        interestRate: null,
        minimumBalance: null,
        maximumBalance: null,
        noOfDaysToDormancy: null,
        noOfDaysToInactive: null,
        coTfeeIncomeAccountNumber: '',
        dueAndUnpaidFeeAccountNumber: '',
        suspendedFeeAccountNumber: '',
        chargeForAccountOpening: false,
        accountOpeningFeeIncomeAccountNumber: '',
        accountOpeningCharge: null,
        accountOpeningNarration: '',
        chargeForAccountMaintenance: false,
        maintenanceFeeID: null,
        accountMaintenanceFeeIncomeAccountNumber: '',
        dueAndUnpaidMaintenanceFeeIncomeAccountNumber: '',
        suspendedMaintenanceFeeIncomeAccountNumber: '',
        minimumMaintenanceBalance: 0,
        maintenanceOnActiveAccountsOnly: false,
        productInterests: [],
        productFees: [],
        smsChargePerNotification: null,
        smsFeeIncomeAccountNumber: null,
        waiveSMSChargeForStaffAccount: false,
        minimumAccountBalanceToStopSendingSMS: null,
        minimumTransactionAmountToSkipSMS: null,
        currencyCode: null,
      },
      interestRate: '',
      feeConditionBasis: '',
      feeID: null,
      interestID: null,
      interestConditionBasis: '',
      productCategoryOptions: productCategory,
      applyOptions: applyInterest,
      camFeeOptions: [],
      overdraftOptions: [],
      creditInterestOptions: [],
      interestExpenseOptions: [],
      interestPayableOptions: [],
      interestInSuspenseOptions: [],
      interestReceivableOptions: [],
      dueAndUnpaidInterestOptions: [],
      accountMaintenanceFeeOptions: [],
      accountOpeningFeeOptions: [],
      vatOptions: [],
      witholdingTaxOptions: [],
      overdraftFeeIncomeOptions: [],
      camFeeIncomeOptions: [],
      overdraftIncomeOptions: [],
      suspendedFeeOptions: [],
      dueAndUnpaidFeesOptions: [],
      conditionalOptions,
      feeDetails: [],
      interestDetails: [],
      permission: '',
      currencyCodeOptions: [],
    }
  },
  computed: {
    feeOptions() {
      return this.applyOptions.filter(item => item.value !== 'Conditional')
    },
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
    window.addEventListener('resize', this.feeInitTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
    window.removeEventListener('resize', this.feeInitTrHeight)
  },
  mounted() {
    const { type, currencyOptions } = this.$route.params
    this.currencyCodeOptions = currencyOptions
    this.actionType = type
    this.getPermission()
    this.getAllCreditInterest()
    this.getOverdraft()
    this.getInterestPayable()
    this.getInterestInSuspense()
    this.getInterestReceivable()
    this.getDueAndUnpaidInterest()
    this.getVATAccount()
    this.getWHTAccount()
    this.getOverdraftFeeIncome()
    this.getOverdraftInterestIncome()
    this.getCAMFeeIncome()
    this.getDueAndUnpaidFees()
    this.getSuspendedFees()
    this.getAccountOpeningFee()
    this.getInterestExpense()
    this.initTrHeight()
    this.feeInitTrHeight()
    this.getCASAProductDetails()
    this.fetchAccountMaintenanceFee()
  },
  methods: {
    ...mapActions({
      getCAMFee: 'account/getCAMFeeList',
      getGLAccountsByAccountType: 'account/getGLAccountsByAccountTypeList',
      getGeneralLedger: 'account/getGeneralLedgerList',
      getCreditInterest: 'account/getInterestList',
      getCAMFeeById: 'account/getCAMFeeById',
      getInterestById: 'account/getInterestById',
      createCASAProduct: 'account/createCASAProductAction',
      updateCASAProduct: 'account/updateCASAProductAction',
      getAccountMaintenanceFee: 'account/getIncomeGLByParentCategory',
      getCASAProduct: 'account/getProduct',
    }),
    repeatProductInterest() {
      if (!this.casaProductFormData.productInterests) {
        this.casaProductFormData.productInterests = []
      }

      this.casaProductFormData.productInterests.push({
        interestConditionValue: null,
        interestCode: null,
        interestID: null,
        interestRate: null,
        useDefaultInterestRate: true,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.productInterest[0].offsetHeight)
      })
    },
    repeatProductFees() {
      if (!this.casaProductFormData.productFees) {
        this.casaProductFormData.productFees = []
      }

      this.casaProductFormData.productFees.push({
        feeCode: '',
        feeID: null,
        flatAmount: null,
        amountPerTrans: null,
        percentageOnTurnover: null,
        minAmountToCharge: null,
        maxAmountToCharge: null,
        feeConditionValue: null,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.productFees[0].offsetHeight)
      })
    },
    removeProductInterestItem(index) {
      this.casaProductFormData.productInterests.splice(index, 1)
      this.trTrimHeight(this.$refs.productInterest[0].offsetHeight)
    },
    removeProductFeeItem(index) {
      this.casaProductFormData.productFees.splice(index, 1)
      this.trTrimHeight(this.$refs.productFees[0].offsetHeight)
    },
    updateValue(event) {
      const { value } = event.target
      if (String(value).length <= 3) {
        this.casaProductFormData.code = value
      }
      this.$forceUpdate()
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    feeInitTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.productFeeForm.scrollHeight)
      })
    },
    getPermission() {
      if (this.actionType === 'save' || this.actionType === 'add') {
        this.permission = accountPermissions.CREATE_SAVING_CURRENT_PRODUCT_NIB
        return
      }
      if (this.actionType === 'edit') {
        this.permission = accountPermissions.MODIFY_SAVING_CURRENT_PRODUCT_NIB
        return
      }
      this.permission = accountPermissions.VIEW_SAVING_CURRENT_PRODUCT_NIB
    },
    setAccountMaintenance(value) {
      if (!value) {
        this.casaProductFormData.maintenanceFeeID = null
        this.casaProductFormData.accountMaintenanceFeeIncomeAccountNumber = null
        this.casaProductFormData.dueAndUnpaidMaintenanceFeeIncomeAccountNumber = null
        this.casaProductFormData.suspendedMaintenanceFeeIncomeAccountNumber = null
        this.casaProductFormData.minimumMaintenanceBalance = null
        return false
      }
      this.casaProductFormData.minimumMaintenanceBalance = this.casaProductFormData.minimumMaintenanceBalance !== 0 ? this.casaProductFormData.minimumMaintenanceBalance : '0'
      return true
    },
    setAccountOpeningCharge(value) {
      if (!value) {
        this.casaProductFormData.accountOpeningCharge = null
        this.casaProductFormData.accountOpeningFeeIncomeAccountNumber = null
        this.casaProductFormData.accountOpeningNarration = null
        return false
      }
      return true
    },
    async createCASAProductAction() {
      const action = `${this.actionType === 'save' || this.actionType === 'add' ? 'Save' : 'Modify'}`
      try {
        this.isLoading = true
        this.isDisabled = true
        this.showBackButton = true
        let productInterests
        let productFees

        if (this.casaProductFormData.productInterests && this.casaProductFormData.productInterests.length) {
          productInterests = this.casaProductFormData.productInterests.map(item => ({
            interestConditionBasis: this.interestConditionBasis,
            interestConditionValue: item.interestConditionValue,
            interestCode: item.interestCode,
            useDefaultInterestRate: true,
            interestRate: item.interestRate,
          }))
        }
        if (this.casaProductFormData.productFees && this.casaProductFormData.productFees.length) {
          productFees = this.casaProductFormData.productFees.map(item => ({
            feeConditionBasis: this.feeConditionBasis,
            feeConditionValue: item.feeConditionValue,
            feeCode: item.feeCode,
          }))
        }

        const formData = {
          ...this.casaProductFormData,
          accountOpeningCharge: toKobo(this.casaProductFormData.accountOpeningCharge),
          minimumBalance: toKobo(this.casaProductFormData.minimumBalance),
          maximumBalance: toKobo(this.casaProductFormData.maximumBalance),
          minimumMaintenanceBalance: Number(toKobo(this.casaProductFormData.minimumMaintenanceBalance)),
          smsChargePerNotification: toKobo(this.casaProductFormData.smsChargePerNotification),
          minimumAccountBalanceToStopSendingSMS: this.casaProductFormData.minimumAccountBalanceToStopSendingSMS ? toKobo(this.casaProductFormData.minimumAccountBalanceToStopSendingSMS) : null,
          minimumTransactionAmountToSkipSMS: this.casaProductFormData.minimumTransactionAmountToSkipSMS ? toKobo(this.casaProductFormData.minimumTransactionAmountToSkipSMS) : null,
          productInterests,
          productFees,
        }

        const { status } = this.actionType === 'save' || this.actionType === 'add'
          ? await this.createCASAProduct(formData)
          : await this.updateCASAProduct(formData)

        if (status === 200) {
          this.alertSuccess({ text: `Your request to ${action} CASA Product was successful` })
          this.$router.push({ name: 'casa-product-list-nib' })
        }
      } catch (error) {
        this.alertError({ text: `Your request to ${action} CASA Product failed. Reason: ${this.readError(error)}` })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async handleSubmit() {
      const action = `${this.actionType === 'save' || this.actionType === 'add' ? 'Save' : 'Modify'}`
      const isFormCompleted = await this.validateChargeConfiguration()
      if (isFormCompleted) {
        this.confirm(this.createCASAProductAction, { title: '', text: `Are you sure you want to ${action} this CASA Product?` })
      }
    },
    async fetchAccountMaintenanceFee() {
      try {
        const { status, data } = await this.getCAMFee({
          search: '',
          page: 0,
          limit: 0,
          permission: this.permission,
        })

        if (status === 200 && data.data.length) {
          this.feeDetails = data.data
          this.accountMaintenanceFeeOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({ label: item.name, value: item.id }))
          this.camFeeOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({ label: item.name, value: item.id, status: item.status }))
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getOverdraft() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 2, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.overdraftOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getAccountOpeningFee() {
      try {
        const { status, data } = await this.getAccountMaintenanceFee({ permission: this.permission })

        if (status === 200 && data.data.length) {
          this.accountOpeningFeeOptions = data.data.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getDueAndUnpaidInterest() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 11, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.dueAndUnpaidInterestOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getSuspendedFees() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 5, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.suspendedFeeOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getDueAndUnpaidFees() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 6, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.dueAndUnpaidFeesOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getOverdraftFeeIncome() {
      try {
        const { status, data } = await this.getGeneralLedger({
          search: { accountCategoryCode: 40102000 },
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        if (status === 200 && data.data.length) {
          this.overdraftFeeIncomeOptions = data.data.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getOverdraftInterestIncome() {
      try {
        const { status, data } = await this.getGeneralLedger({
          search: { accountCategoryCode: 40304000 },
          page: 0,
          limit: 0,
          permission: this.permission,
        })

        if (status === 200 && data.data.length) {
          // this.overdraftIncomeOptions = data.data.filter(item => item.status === 'Active').map(item => ({ label: item.name, value: item.code.toString() }))
          this.overdraftIncomeOptions = data.data.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getInterestInSuspense() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 10, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.interestInSuspenseOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getVATAccount() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 26, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.vatOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getWHTAccount() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 27, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.witholdingTaxOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getInterestReceivable() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 13, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.interestReceivableOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getCAMFeeIncome() {
      try {
        const { status, data } = await this.getGeneralLedger({
          search: { AccountCategoryCode: 40102000 },
          page: 0,
          limit: 0,
          permission: this.permission,
        })

        if (status === 200 && data.data.length) {
          this.camFeeIncomeOptions = data.data.filter(item => item.status.toLowerCase() === 'active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getInterestPayable() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 12, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.interestPayableOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getInterestExpense() {
      try {
        const { status, data } = await this.getGLAccountsByAccountType({ accountType: 14, permission: this.permission })

        if (status === 200 && data.data.length) {
          this.interestExpenseOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    setApplyFee(selectedValue) {
      if (selectedValue === 'True') {
        this.isApplyFee = true
        this.isConditionalFee = false
        this.casaProductFormData.productFees = []
      } else if (selectedValue === 'False') {
        this.isApplyFee = false
        this.isConditionalFee = false
        this.casaProductFormData.productFees = []
      } else {
        this.isApplyFee = false
        this.isConditionalFee = true
      }
    },
    setApplyCreditInterest(selectedValue) {
      if (selectedValue === 'True') {
        this.isCreditInterest = true
        this.isConditional = false
        this.showAddProductInterest = false
      } else if (selectedValue === 'False') {
        this.isCreditInterest = false
        this.isConditional = false
        this.showAddProductInterest = false
      } else {
        this.isCreditInterest = false
        this.isConditional = true
      }
    },
    async setCreditInterestFee(selectedValue) {
      try {
        const { data } = await this.getInterestById({ id: selectedValue, permission: this.permission })
        this.interestRate = data.data.rate.toString()
        this.casaProductFormData.interestCode = data.data.code
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async setProductCreditInterestFee(selectedValue) {
      try {
        const { status, data } = await this.getInterestById({ id: selectedValue, permission: this.permission })
        if (status === 200 && Object.entries(data.data).length) {
          const index = this.casaProductFormData.productInterests.findIndex(item => item.interestID === selectedValue)

          this.casaProductFormData.productInterests[index].interestRate = data.data.rate
          this.casaProductFormData.productInterests[index].interestCode = data.data.code
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async setCAMFees(selectedValue) {
      try {
        const { status, data } = await this.getCAMFeeById({ id: selectedValue, permission: this.permission })

        if (status === 200) {
          this.nonEditable.flatAmount = data.data.flatAmount
          this.nonEditable.amountPerTrans = formatAmount(data.data.flatAmountPerTransaction.toString())
          this.nonEditable.percentageOnTurnover = data.data.percentageOnTurnover.toString()
          this.nonEditable.minAmountToCharge = formatAmount(data.data.minimumAmount.toString())
          this.nonEditable.maxAmountToCharge = formatAmount(data.data.maximumAmount.toString())
          this.casaProductFormData.feeCode = data.data.code
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async setProductCAMFee(selectedValue) {
      try {
        const { status, data } = await this.getCAMFeeById({ id: selectedValue, permission: this.permission })

        if (status === 200 && Object.entries(data.data).length) {
          const index = this.casaProductFormData.productFees.findIndex(item => item.feeID === selectedValue)

          this.casaProductFormData.productFees[index].flatAmount = data.data.flatAmount.toString()
          this.casaProductFormData.productFees[index].maxAmountToCharge = data.data.maximumAmount.toString()
          this.casaProductFormData.productFees[index].minAmountToCharge = data.data.minimumAmount.toString()
          this.casaProductFormData.productFees[index].percentageOnTurnover = data.data.percentageOnTurnover.toString()
          this.casaProductFormData.productFees[index].amountPerTrans = data.data.flatAmountPerTransaction.toString()
          this.casaProductFormData.productFees[index].feeCode = data.data.code
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getCreditInterestById(selectedValue) {
      try {
        const { status, data } = await this.getInterestById({ id: selectedValue, permission: this.permission })
        if (status === 200 && data.data) {
          this.interestRate = data.data.rate
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    setProductInterest(selectedValue) {
      this.isInterestNoOfWithdrawal = selectedValue === 'NoOfWithdrawals'
      this.showAddProductInterest = this.actionType !== 'view'
      // this.casaProductFormData.productInterests = []
    },
    setProductFee(selectedValue) {
      this.isFeeNoOfWithdrawal = selectedValue === 'NoOfWithdrawals'
      this.showAddProductFee = this.actionType !== 'view'
      // this.casaProductFormData.productFees = []
    },
    async getAllCreditInterest() {
      try {
        const { status, data } = await this.getCreditInterest({
          search: '',
          page: 0,
          limit: 0,
          permission: this.permission,
        })

        if (status === 200 && data.data.length) {
          this.interestDetails = data.data
          this.creditInterestOptions = data.data.filter(dataItem => dataItem.status.toLowerCase() === 'active' && dataItem.type.toLowerCase() === 'credit').map(item => ({ label: item.name, value: item.id }))
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getCASAProductDetails() {
      try {
        const { id, type } = this.$route.params
        if (id !== undefined) {
          this.showSpinner = true
          this.showBackButton = true
          this.actionType = type
          this.isReadonly = type !== 'edit'
          this.isDisabled = type !== 'edit'
          this.$refs.casaProduct.activateAll()

          const { status, data } = await this.getCASAProduct({ id, permission: this.permission })

          if (status === 200) {
            this.isEditProductCode = true
            this.setApplyFee(data.data.applyFee)
            this.setApplyCreditInterest(data.data.applyCreditInterest)
            if (data.data.feeID) {
              this.feeID = data.data.feeID
              await this.setCAMFees(data.data.feeID)
            }
            if (data.data.interestID) {
              this.interestID = data.data.interestID
              await this.setCreditInterestFee(data.data.interestID)
            }
            let productInterests
            if (data.data.applyCreditInterest === 'Conditional' && data.data.interests.length) {
              await this.setProductInterest(data.data.interests[0].interestConditionBasis)
              this.interestConditionBasis = data.data.interests[0].interestConditionBasis
              productInterests = data.data.interests.map(item => ({
                ...item,
                interestRate: item.interestRate || '0',
                interestConditionValue: item.interestConditionValue || '0',
              }))
            }
            let productFees
            if (data.data.applyFee === 'Conditional' && data.data.fees.length) {
              await this.setProductFee(data.data.fees[0].feeConditionBasis)
              this.feeConditionBasis = data.data.fees[0].feeConditionBasis
              productFees = data.data.fees.map(item => ({
                ...item,
                amountPerTrans: item.flatAmountPerTransaction || '0',
                minAmountToCharge: item.minimumAmount || '0',
                maxAmountToCharge: item.maximumAmount || '0',
                feeConditionValue: item.feeConditionValue || '0',
                percentageOnTurnover: item.percentageOnTurnover || '0',
              }))
            }

            this.casaProductFormData = {
              id,
              code: data.data?.code,
              name: data.data?.name,
              accountNumberPrefix: data.data?.accountNumberPrefix,
              category: data.data?.category,
              overdraftAccountNumber: data.data?.overdraftAccountNumber,
              interestPayableAccountNumber: data.data?.interestPayableAccountNumber,
              interestExpenseAccountNumber: data.data?.interestExpenseAccountNumber,
              interestReceivableAccountNumber: data.data?.interestReceivableAccountNumber,
              interestDueAndUnpaidAccountNumber: data.data?.interestDueAndUnpaidAccountNumber,
              interestSuspenseAccountNumber: data.data?.interestSuspenseAccountNumber,
              overdraftFeeIncomeAccountNumber: data.data?.overdraftFeeIncomeAccountNumber,
              overdraftInterestIncomeAccountNumber: data.data?.overdraftInterestIncomeAccountNumber,
              vaTaccountNumber: data.data?.vaTaccountNumber,
              whTaccountNumber: data.data?.whTaccountNumber,
              applyFee: data.data?.applyFee,
              feeCode: data.data?.feeCode,
              interestCode: data.data?.interestCode,
              applyCreditInterest: data.data?.applyCreditInterest,
              minimumBalance: data.data?.minimumBalance ? formatAmount(data.data?.minimumBalance) : '0',
              maximumBalance: data.data?.maximumBalance ? formatAmount(data.data?.maximumBalance) : '0',
              noOfDaysToDormancy: data.data?.noOfDaysToDormancy || '0',
              noOfDaysToInactive: data.data?.noOfDaysToInactive || '0',
              coTfeeIncomeAccountNumber: data.data?.coTfeeIncomeAccountNumber,
              dueAndUnpaidFeeAccountNumber: data.data?.dueAndUnpaidFeeAccountNumber,
              suspendedFeeAccountNumber: data.data?.suspendedFeeAccountNumber,
              chargeForAccountOpening: data.data?.chargeForAccountOpening,
              accountOpeningFeeIncomeAccountNumber: data.data?.accountOpeningFeeIncomeAccountNumber,
              accountOpeningCharge: data.data?.accountOpeningCharge ? formatAmount(data.data?.accountOpeningCharge) : '0',
              accountOpeningNarration: data.data?.accountOpeningNarration,
              chargeForAccountMaintenance: data.data?.chargeForAccountMaintenance,
              maintenanceFeeID: data.data?.maintenanceFeeID,
              accountMaintenanceFeeIncomeAccountNumber: data.data?.accountMaintenanceFeeIncomeAccountNumber,
              dueAndUnpaidMaintenanceFeeIncomeAccountNumber: data.data?.dueAndUnpaidMaintenanceFeeIncomeAccountNumber,
              suspendedMaintenanceFeeIncomeAccountNumber: data.data?.suspendedMaintenanceFeeIncomeAccountNumber,
              minimumMaintenanceBalance: data.data?.minimumMaintenanceBalance ? formatAmount(data.data?.minimumMaintenanceBalance) : '0',
              maintenanceOnActiveAccountsOnly: data.data?.maintenanceOnActiveAccountsOnly,
              productInterests,
              productFees,
              smsChargePerNotification: data.data?.smsChargePerNotification ? formatAmount(data.data?.smsChargePerNotification) : '0',
              smsFeeIncomeAccountNumber: data.data?.smsFeeIncomeAccountNumber,
              waiveSMSChargeForStaffAccount: data.data?.waiveSMSChargeForStaffAccount,
              minimumAccountBalanceToStopSendingSMS: data.data?.minimumAccountBalanceToStopSendingSMS ? formatAmount(data.data?.minimumAccountBalanceToStopSendingSMS) : null,
              minimumTransactionAmountToSkipSMS: data.data?.minimumTransactionAmountToSkipSMS ? formatAmount(data.data?.minimumTransactionAmountToSkipSMS) : null,
              currencyCode: data.data?.currencyCode,
            }
            this.showSpinner = false
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'casa-product-list-nib',
      })
    },

    validateSavings() {
      return new Promise((resolve, reject) => {
        this.$refs.savingRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateCAM() {
      return new Promise((resolve, reject) => {
        this.$refs.camRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateCredit() {
      return new Promise((resolve, reject) => {
        this.$refs.creditRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateReporting() {
      return new Promise((resolve, reject) => {
        this.$refs.reportingRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateFee() {
      return new Promise((resolve, reject) => {
        this.$refs.feeRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateAccountMaintenance() {
      return new Promise((resolve, reject) => {
        this.$refs.maintenanceRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateChargeConfiguration() {
      return new Promise((resolve, reject) => {
        this.$refs.chargeConfigurationRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}

</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  .credit {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-column-gap: 1.25rem;
    margin-bottom: 2rem
  }
  .disabled {
    background-color: '#fff' !important;
  }
  .repeater-form {
    overflow: inherit !important;
  transition: .35s height;
}

</style>
